<template>
	<div class="statistics">
		<div class="statistics__section">
			<div class="statistics__search-area">
				<input
					@input="searchValue"
					class="statistics__search"
					placeholder="search"
					ref="searchKey"
					type="text"
				/>
				<Transition name="button" mode="out-in">
					<button
						v-if="keyword"
						@click="removeSearch"
						class="item__remove"
					>
						<i class="fa fas fa-minus"></i>
					</button>
				</Transition>
			</div>
			<button
				class="btn-excel section__info__items"
				type="button"
				@click="excelDown"
			>
				엑셀 다운로드
			</button>
		</div>
		<table class="simple-table">
			<thead>
				<tr>
					<th
						v-for="(head, index) in title"
						:key="index"
						class="statistics__title"
					>
						{{ head }}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(body, index) in filteredTopList"
					:key="index"
					class="group-item"
				>
					<td class="statistics__realRank">{{ body.realRank }}</td>
					<td v-if="type === 'category'" class="statistics__category">
						{{ body.secondCategoryText || '-' }}
					</td>
					<td v-if="type === 'category'" class="statistics__category">
						{{ body.thirdCategoryText || '-' }}
					</td>
					<td
						v-if="type === 'brand' || type === 'product'"
						class="statistics__brand-title"
					>
						{{ body.brandTitle || '-' }}
					</td>
					<td
						v-if="type === 'product'"
						class="statistics__product-title"
					>
						{{ body.productTitle || '-' }}
					</td>
					<td class="statistics__cnt">{{ body.cnt }}</td>
					<td
						v-if="type === 'product'"
						class="statistics__product-id"
					>
						{{ body.idProduct || '-' }}
					</td>
				</tr>
			</tbody>
		</table>
		<PaginationBox
			:limit="limit"
			:offset="offset"
			:totalItem="totalItem"
			@to="onPagination($event.offset)"
			slot="pagination"
			class="statistics__pagination"
		/>
	</div>
</template>
<script>
	import PaginationBox from '@/components/PaginationBox';
	import Util from '@/util';
	export default {
		props: {
			title: {
				type: Array,
				default: [],
			},
			type: {
				type: String,
				default: 'category',
			},
		},
		components: {
			PaginationBox,
		},
		data() {
			return {
				topList: [],
				pagingList: [],
				pageNumber: 1,
				totalItem: 0,
				offset: 0,
				limit: 15,
				configUrl: '',
				keyword: '',
				typeAttributes: {
					category: [
						'realRank',
						'secondCategoryText',
						'thirdCategoryText',
						'cnt',
					],
					brand: ['realRank', 'brandTitle', 'cnt'],
					product: [
						'realRank',
						'brandTitle',
						'productTitle',
						'cnt',
						'idProduct',
					],
				},
			};
		},
		computed: {
			filteredTopList() {
				if (this.keyword === '') {
					this.totalItem = this.topList.length;
					return this.pagingList;
				}
				const attributes = this.typeAttributes[this.type] || [];

				const filteredList = this.topList.filter(item => {
					return attributes.some(attr => {
						const value = String(item[attr]);
						return value.includes(this.keyword);
					});
				});

				this.totalItem = filteredList.length;
				this.offset = 0;
				return filteredList;
			},
		},
		created() {
			switch (this.type) {
				case 'brand':
					this.getTopBrand();
					break;
				case 'category':
					this.getTopCategory();
					break;
				case 'product':
					this.getTopProduct();
					break;
				default:
					break;
			}
		},
		methods: {
			async getList(endpoint) {
				try {
					const { data, config } = await this.$axiosAdmin2.get(
						`/api/aggregate/review/${endpoint}`
					);
					this.configUrl = config.url;
					this.topList = [...data];
					this.totalItem = this.topList.length;
					this.pagingList = this.topList.slice(0, this.limit);
				} catch (err) {
					console.error(err);
					alert(
						'리스트를 불러오는데 실패하였습니다. 계속적인 문제 발생시 개발팀에 문의주세요.'
					);
				}
			},
			async getTopBrand() {
				await this.getList('brand-top');
			},
			async getTopCategory() {
				await this.getList('category-top');
			},
			async getTopProduct() {
				await this.getList('product-top');
			},
			onPagination(offset) {
				const endIndex = offset + this.limit;
				this.pageNumber = offset / this.limit + 1;
				this.pagingList = this.topList.slice(offset, endIndex);
				this.offset = offset;
			},
			excelDown() {
				const clickCb = () => {
					const attributes = this.typeAttributes[this.type] || [];
					const rows = this.topList.map(item =>
						attributes.map(attr => item[attr])
					);
					const title = `top_${this.type} by review_${Date.now()}`;
					Util.getCsv(
						[rows],
						[title],
						[this.title],
						`글로우픽_${title}`,
						this.configUrl
					);
				};
				clickCb();
			},
			removeSearch() {
				this.keyword = '';
				this.$refs.searchKey.value = '';
			},
			searchValue(e) {
				this.keyword = e.target.value;
			},
		},
	};
</script>
<style lang="scss" scoped>
	.statistics {
		margin-top: 50px;
		.btn-excel {
			border-radius: 4px !important;
		}
		.item__remove {
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background: #ff3860;
			color: #fff;
		}
		&__section {
			display: flex;
			justify-content: space-between;
			margin-bottom: 20px;
		}

		&__search-area {
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 10px;
			position: relative;
			button {
				position: absolute;
				right: 0;
			}
		}

		&__search {
			margin-left: 10px;
			width: 300px !important;
			padding: 0 30px 0 12px !important;
			font-size: 16px;
			color: #fff;
			letter-spacing: 1px;
			border: none !important;
			border-bottom: 1px solid #dfe6ee !important;
			outline: none;
			background: transparent;
		}

		&__title {
			text-align: center;
			padding-left: 0;
		}

		&__realRank {
			width: 20px;
			text-align: center;
		}

		&__cnt {
			text-align: center;
			width: 30px;
		}

		&__category {
			text-align: center;
		}

		&__product-title {
			text-align: center;
		}

		&__brand-title {
			text-align: center;
		}

		&__product-id {
			width: 20px;
			text-align: center;
		}

		&__pagination {
			margin-top: 30px;
		}
	}

	.button-enter-active,
	.button-leave-active {
		transition: opacity 0.3s ease-in-out;
	}

	.button-enter-from,
	.button-leave-to {
		opacity: 0;
	}
</style>
